import * as React from "react";
import TextField from "@mui/material/TextField";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import SendIcon from "@mui/icons-material/Send";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import GitHubIcon from "@mui/icons-material/GitHub";
import Button from '@mui/material/Button';
import Snackbar from '@mui/material/Snackbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import axios from 'axios';
import { IMaskInput } from 'react-imask';
import { useForm } from "react-hook-form";


const PersonalInformation = () => {
  return (
    <>
      <p className="text-sm text-white font-bold mt-4">Telefono:</p>

      <p className="text-sm text-main">(744) - 3811074</p>

      <p className="text-sm text-white font-bold mt-3">Email:</p>

      <p className="text-sm text-main">imperiojesus89@gmail.com</p>

      <p className="text-sm text-white font-bold mt-3">Telegram:</p>

      <p className="text-sm text-main ">@thejesus890</p>

      <p className="text-sm text-white font-bold mt-3">Residencia:</p>

      <p className="text-sm text-main ">Coyoacán, CDMX</p>
    </>
  );
};


const PhoneMask = React.forwardRef(function PhoneMask(props, ref) {
  const { onChange, ...other } = props;

  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        '#': /[1-9]/,
      }}
      inputRef={ref}
      onAccept={(value) =>
        onChange({
          target: {
            name: props.name,
            value,
          },
        })
      }
      overwrite
    />
  );
});


function ContactInformation({ isMobile = false }) {

  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
  });


  const handleClose = (event, reason) => {
    if (reason === 'clickaway')
      return;
    setSnackbar({...snackbar, open: false});
  };

  //action snackbar
  const action = (
    <React.Fragment>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small"  className="text-amarillo"/>
      </IconButton>
    </React.Fragment>
  );

  //estilo del card
  const styleCard = {
    width: "100%",
    height: "auto",
    marginTop: isMobile ? "20px" : "10px",
    background: "linear-gradient(45deg, #32323e, #595a60)",
    color: "white",
    padding: "10px",
    position: "relative",
    display: "block",
  };

  //estilo de los componentes
  const styleText = {
    input: { color: "white", fontSize: "14px" },
    textarea: { color: "white", fontSize: "14px" },
    label: { color: "white", fontSize: "14px" },
    "&:hover label": {
      color: "#ffc107", // color al hacer hover
    },
    "& label.Mui-focused": {
      color: "#ffc107",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "white", // línea antes del enfoque
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottomColor: "#ffc107", // línea al hacer hover
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#ffc107", // línea después del enfoque
    },
    "& .MuiFormHelperText-root": {
      color: "#e57373", // color helper error
    },
    "& .MuiInputLabel-root.Mui-error": {
      color: "#e57373", // label cuando hay error
    },
    marginTop: "10px",
    marginBottom: "10px",
  };

  //estilo del button
  const styleButton = {
    backgroundColor: "#ffc107",
    color: "#1e1e28",
    "&:hover": {
      backgroundColor: "#ffb300",
    },
    marginTop: "10px",
    width: "200px",
    marginLeft: isMobile ? "0%" : "20%",
  };

  //react-hook-form
  const { register, handleSubmit, reset, formState: { errors }} = useForm();

  //envia el mensaje
  const onSubmit = async(data) => {
    try
    {
      const response = await axios.post(
        `${process.env.REACT_APP_LARAVEL_API}/buzon`,
        data
      );

      setSnackbar({message: response.data.message, open: true});
    }
    catch(ex)
    {
      setSnackbar({message: "Ocurrió un error inesperado", open: true});
    }

    //limpia los datos despues de mandar una solicitud
    reset();
  };

  return (
    <div className="w-full h-full bg-negro">
      
      {/* Snackbar de alertas */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={handleClose}
        message={snackbar.message}
        action={action}
        anchorOrigin={{vertical: 'bottom', horizontal: 'right'}}
        ContentProps={{
          sx: {
            backgroundColor: "#2d2d3a",
            color: "#fff",
          },
        }}
      />
      
      <div className={`${!isMobile ? "grid grid-cols-[52%_46%] gap-2" : ""} `}>
        <Card sx={styleCard}>
          <CardContent sx={{ padding: 0 }}>
            <p className="text-white text-[17px] font-semibold">
              Formulario de Contacto
            </p>
 
            
            <div className={`${!isMobile ? "w-[70%] ml-10" : "w-full p-2"}`}>
              <form onSubmit={handleSubmit(onSubmit)}>
                <TextField
                  id="name"
                  label="Nombre"
                  variant="standard"
                  sx={styleText}
                  fullWidth
                  error={!!errors.name}
                  helperText={errors.name ? "Campo faltante" : ""}
                  {...register("name", { required: true, maxLength: 80 })}
                />

                <TextField
                  id="email"
                  label="Email"
                  variant="standard"
                  sx={styleText}
                  fullWidth
                  error={!!errors.email}
                  helperText={errors.email ? "Campo faltante o inválido" : ""}
                  {...register("email", {
                    required: true,
                    pattern: /^\S+@\S+$/i,
                  })}
                />

                <TextField
                  id="phone"
                  label="Teléfono"
                  variant="standard"
                  sx={styleText}
                  fullWidth
                  error={!!errors.phone}
                  helperText={errors.phone ? "Campo faltante" : ""}
                  InputProps={{
                    inputComponent: PhoneMask,
                  }}
                  {...register("phone", { required: true, maxLength: 15 })}
                />

                <TextField
                  id="message"
                  label="Mensaje"
                  variant="standard"
                  sx={styleText}
                  fullWidth
                  multiline
                  rows={isMobile ? 3 : 4}
                  error={!!errors.message}
                  helperText={errors.message ? "Campo faltante" : ""}
                  {...register("message", { required: true, maxLength: 220 })}
                />

                <Button
                  type="submit"
                  role={undefined}
                  variant="contained"
                  startIcon={<SendIcon />}
                  sx={styleButton}
                >
                  Enviar
                </Button>
              </form>
            </div>
          </CardContent>
        </Card>

        <Card sx={styleCard}>
          <CardContent sx={{ padding: 0 }}>
            <p className="text-white text-[17px] font-semibold">
              Información de Contacto
            </p>

            <div className="p-1">
              <PersonalInformation />

              <div className="flex mt-4">
                <a
                  href="https://www.facebook.com/jesuss89/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FacebookOutlinedIcon />
                </a>
                <a
                  href="https://www.instagram.com/thejesus89/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <InstagramIcon className="ml-4" />
                </a>
                <a
                  href="https://www.linkedin.com/in/jesus-gomez-urbano-0b7a23210/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <LinkedInIcon className="ml-4" />
                </a>
                <a
                  href="https://github.com/jesus890"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <GitHubIcon className="ml-4" />
                </a>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}

export default ContactInformation;
